function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.7,
  cx: 82,
  cy: 82,
  r: 52,
  fill: "#F5841F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M82.5 72.0538C83.3331 72.0538 84.0084 72.7291 84.0084 73.5622V83.6184C84.0084 84.4515 83.3331 85.1269 82.5 85.1269C81.6669 85.1269 80.9916 84.4515 80.9916 83.6184V73.5622C80.9916 72.7291 81.6669 72.0538 82.5 72.0538ZM82.5 92.1662C83.6108 92.1662 84.5112 91.2657 84.5112 90.155C84.5112 89.0442 83.6108 88.1437 82.5 88.1437C81.3892 88.1437 80.4888 89.0442 80.4888 90.155C80.4888 91.2657 81.3892 92.1662 82.5 92.1662ZM78.5559 61.3067C80.2859 58.2311 84.7141 58.2311 86.4441 61.3067L103.912 92.3611C105.609 95.3777 103.429 99.105 99.9681 99.105H65.0319C61.5708 99.105 59.3909 95.3777 61.0877 92.3611L78.5559 61.3067ZM83.8147 62.7858C83.238 61.7606 81.762 61.7606 81.1853 62.7858L63.7172 93.8402C63.1516 94.8457 63.8782 96.0882 65.0319 96.0882H99.9681C101.122 96.0882 101.848 94.8457 101.283 93.8402L83.8147 62.7858Z",
  fill: "white"
});

function SvgUploadWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadWarning);
export default __webpack_public_path__ + "static/media/upload_warning.fb6541e9.svg";
export { ForwardRef as ReactComponent };